/**
 * PhonesProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import PhonesContext from './phones-context'
import { validatePhone } from './phones-api'

export default function PhonesProvider({ children }) {
  const state = {
    validatePhone
  }
  return (
    <PhonesContext.Provider value={state}>
      {children}
    </PhonesContext.Provider>
  )
}
